import { isTransientError } from "./transientErrors";
import { TELEMETRY_CATEGORIES, TELEMETRY_EVENTS, trackEvent } from "../../telemetry";

const listeners = new Set();

export function subscribeRetryTelemetry(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function emitRetryTelemetry(eventName, context, extra = {}) {
  const payload = {
    operationId: context.operationId,
    phase: context.phase,
    domain: context.domain,
    toolId: context.toolId,
    ...extra,
  };

  if (process.env.NODE_ENV !== "production") {
    console.info(`[retry-telemetry] ${eventName}`, payload);
  }

  trackEvent(
    TELEMETRY_EVENTS.RETRY_EVENT,
    {
      retryEvent: eventName,
      ...payload,
    },
    {
      category: TELEMETRY_CATEGORIES.RETRY,
      dedupeKey: `${eventName}:${payload.operationId ?? payload.phase ?? "unknown"}`,
    },
  );

  for (const listener of listeners) {
    listener(eventName, payload);
  }
}

export function emitRetryAttemptTelemetry(context, event, exhausted) {
  emitRetryTelemetry(exhausted ? "retry_exhausted" : "retry_scheduled", context, {
    attempt: event.attempt,
    maxAttempts: event.maxAttempts,
    delayMs: event.delayMs,
    isTransient: isTransientError(event.error),
    errorMessage: event.error instanceof Error ? event.error.message : String(event.error),
  });
}
